import { LIVE_MEETING_STATUSES } from "@lexicanon/shared"

/**
 * Whether a meeting in the given lifecycle phase can be reprocessed.
 *
 * Reprocessing re-runs the analysis pipeline, so it must NOT be offered while
 * the meeting is still being captured or processed for the first time — a
 * running pipeline would clobber its own output. Any phase that has stopped
 * recording and finished (or failed) its initial pass is eligible: that's
 * `summarized`, but also `ended`, `fetched`, `recovering` and `error` — the
 * detail-view exclusion semantics, which are the authority here. The card-grid
 * previously gated on `status === "summarized"` alone, hiding reprocess for
 * `ended`/`error` meetings that the detail page allowed; this single helper
 * removes that drift.
 *
 * Built on `LIVE_MEETING_STATUSES` (detected / in_progress / transcribed /
 * parsed) so a status rename stays a single-file edit caught at compile time.
 */
export function canReprocess(status: string): boolean {
  return !LIVE_MEETING_STATUSES.has(status)
}
